<div class="amp-loader">
  <div class="animate__animated amp-loader-chip" [ngClass]="{'animate__backOutUp': !show, 'animate__fadeInDownBig': show}">
      <img class="animate-img" src="/assets/img/014-rotate.svg"/>  Carregando
  </div>
</div>
